import React from "react";
import Modal from "react-bootstrap/Modal";

function RejectedModal({ show, createMsg, setShow, SuccessDoneClick }) {
  const handleHide = SuccessDoneClick || (() => setShow(false));

  return (
    <Modal
      size="sm"
      show={show}
      centered
      className="rejectedModal"
      onHide={handleHide}
    >
      <Modal.Body>
        <div className="rejectedModal__content">
          <svg
            className="rejectedModal__icon"
            viewBox="0 0 96 112"
            role="img"
            aria-label="Rejected"
          >
            <path
              d="M48 4 88 19v34c0 25-16 42-40 55C24 95 8 78 8 53V19L48 4Z"
              fill="#FFFFFF"
            />
            <path
              d="m31 36 34 34m0-34L31 70"
              fill="none"
              stroke="#EF4444"
              strokeWidth="9"
              strokeLinecap="round"
            />
          </svg>
          <h6 className="rejectedModal__title">Rejected</h6>
          <p className="rejectedModal__message">{createMsg?.message}</p>
          <button
            type="button"
            className="btn rejectedModal__done"
            onClick={handleHide}
          >
            Done
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RejectedModal;
